import React, { Component } from "react";
import { Card, Typography, Row, Col } from "antd";
import config from "../../../config";

const { Text, Title } = Typography;

class FulfilledShipmentDetails extends Component {
    renderShipmentItem = (item) => {
        const { shipment } = this.props;

        const cdnUrl = shipment.brand ? config.shopifyCdn[shipment.brand.toLowerCase()] : config.shopifyCdn.us;
        const imageSrc = item.imageUrl || item.image_url ? cdnUrl + '/' + (item.imageUrl || item.image_url).split('/').pop() : '';

        return (
            <Card
                key={`${item.sku || item.shipment_item_id}-${Math.random()}`}
                size="small"
                style={{
                    marginBottom: '12px',
                    display: 'inline-block',
                    width: '200px',
                    marginRight: '12px'
                }}
                bodyStyle={{ padding: '12px' }}
            >
                <div style={{ marginBottom: '8px' }}>
                    <img
                        src={imageSrc}
                        alt={item.name}
                        style={{
                            width: '100%',
                            height: '120px',
                            objectFit: 'contain',
                            borderRadius: '4px',
                            border: '1px solid #d9d9d9'
                        }}
                    />
                </div>
                <div>
                    <Text strong style={{ fontSize: '14px', display: 'block', marginBottom: '8px' }}>
                        {item.name}
                    </Text>
                    <div style={{ marginBottom: '4px' }}>
                        <Text type="secondary" strong>Size: </Text>
                        <Text>{item.size}</Text>
                    </div>
                    <div>
                        <Text type="secondary" strong>SKU: </Text>
                        <Text style={{ fontFamily: 'monospace', fontSize: '12px' }}>{item.sku}</Text>
                    </div>
                </div>
            </Card>
        );
    };

    canMapAllItems = () => {
        const { shipment } = this.props;

        if (!shipment.packages || !shipment.shipment_items) {
            return false;
        }

        // Check if every package item can be mapped to a shipment item
        const canMapAll = shipment.packages.every(packageData => 
            packageData.shipment_items.every(packageItem =>
                shipment.shipment_items.some(fullItem => 
                    fullItem.shipment_item_id === packageItem.shipment_item_id
                )
            )
        );

        if (!canMapAll) {
            console.warn(`[FulfilledShipmentDetails] Cannot map all package items to shipment items for shipment ${shipment.shipment_id || shipment.shipmentId}. Falling back to ungrouped display.`);
        }

        return canMapAll;
    };

    renderPackageGroup = (packageData, packageIndex) => {
        const { shipment } = this.props;

        // Get the full shipment item details for each item in this package
        const packageItems = packageData.shipment_items.map(packageItem => {
            return shipment.shipment_items?.find(fullItem => 
                fullItem.shipment_item_id === packageItem.shipment_item_id
            );
        });

        return (
            <div key={packageIndex} style={{ marginBottom: '24px' }}>
                <Title level={5} style={{ margin: 0, marginBottom: '12px', color: '#1890ff' }}>
                    Package #{packageIndex + 1}
                    <Text type="secondary" style={{ fontSize: '14px', fontWeight: 'normal', marginLeft: '8px' }}>
                        (Weight: {packageData.final_weight}kg)
                    </Text>
                </Title>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0', paddingLeft: '16px' }}>
                    {packageItems.map(item => this.renderShipmentItem(item))}
                </div>
            </div>
        );
    };

    render() {
        const { shipment } = this.props;

        return (
            <div style={{ padding: '16px' }}>
                {/* Shipment Summary */}
                <Card size="small" style={{ marginBottom: '16px' }}>
                    <Title level={4} style={{ margin: 0, marginBottom: '12px' }}>
                        Details
                    </Title>
                    <Row gutter={16}>
                        <Col span={8}>
                            <Text type="secondary" strong>Shipment ID: </Text>
                            <Text style={{ fontFamily: 'monospace' }}>
                                {shipment.shipmentId?.substring(0, 13) || 'N/A'}
                            </Text>
                        </Col>
                        <Col span={8}>
                            <Text type="secondary" strong>Customer: </Text>
                            <Text>{shipment.customerName || shipment.customer_name || 'N/A'}</Text>
                        </Col>
                        <Col span={8}>
                            <Text type="secondary" strong>Carrier: </Text>
                            <Text>{shipment.carrier}</Text>
                        </Col>
                    </Row>
                    <Row gutter={16} style={{ marginTop: '8px' }}>
                        <Col span={8}>
                            <Text type="secondary" strong>Status: </Text>
                            <Text>{shipment.status}</Text>
                        </Col>
                        <Col span={8}>
                            <Text type="secondary" strong>Fulfilled At: </Text>
                            <Text>
                                {shipment.fulfilledAt 
                                    ? new Date(shipment.fulfilledAt).toLocaleDateString('en-AU', {
                                        year: 'numeric',
                                        month: '2-digit',
                                        day: '2-digit',
                                        hour: '2-digit',
                                        minute: '2-digit'
                                    })
                                    : 'N/A'
                                }
                            </Text>
                        </Col>
                        <Col span={8}>
                            <Text type="secondary" strong>Method: </Text>
                            <Text>{shipment.shipping_method || shipment.method || 'N/A'}</Text>
                        </Col>
                    </Row>
                </Card>

                {/* Products */}
                <Card size="small">
                    <Title level={4} style={{ margin: 0, marginBottom: '12px' }}>
                        Products ({shipment.shipment_items?.length || shipment.items?.length || 0} item{(shipment.shipment_items?.length || shipment.items?.length) !== 1 ? 's' : ''})
                    </Title>

                    {this.canMapAllItems() ? (
                        <div>
                            {shipment.packages.map((packageData, index) => 
                                this.renderPackageGroup(packageData, index)
                            )}
                        </div>
                    ) : (
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0' }}>
                            {(shipment.shipment_items || shipment.items) && (shipment.shipment_items || shipment.items).length > 0 ? (
                                (shipment.shipment_items || shipment.items).map(item => this.renderShipmentItem(item))
                            ) : (
                                <Text type="secondary">No product information available</Text>
                            )}
                        </div>
                    )}
                </Card>
            </div>
        );
    }
}

export default FulfilledShipmentDetails;